import React from "react"
import {Col, Row} from "antd"
import {useTranslation} from "react-i18next"
import {FormLabel} from "components/Form"
import {getFullName} from "helpers"
import {SmsPhoneNumberDialerDetailResponse} from "types/sms-dialer-settings"
import styles from "./PhoneNumberDetails.module.css"

type Props = {
    phone: SmsPhoneNumberDialerDetailResponse["phone"]
}

const SmsPhoneNumberGeneralInfo: React.FC<Props> = ({phone}) => {
    const {t} = useTranslation(["settings"])

    const campuses = (phone.campuses ?? []).map((c) => c.name).join(", ") || t("smsSettings.dialerSettings.noValue")
    const departments =
        (phone.departments ?? []).map((d) => d.name).join(", ") || t("smsSettings.dialerSettings.noValue")
    const userName = phone.user ? getFullName(phone.user) : t("smsSettings.dialerSettings.noValue")
    const dialerDept = phone.departmentForDialer?.name || t("smsSettings.dialerSettings.noValue")

    return (
        <div>
            <h3 className={styles.subtitle}>{t("smsSettings.dialerSettings.generalInfo")}</h3>
            <Row gutter={[40, 24]}>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.user")} />
                    <div className={styles.readonlyField}>{userName}</div>
                </Col>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.campus")} />
                    <div className={styles.readonlyField}>{campuses}</div>
                </Col>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.department")} />
                    <div className={styles.readonlyField}>{departments}</div>
                </Col>
                <Col span={12}>
                    <FormLabel label={t("smsSettings.dialerSettings.departmentForDialer")} />
                    <div className={styles.readonlyField}>{dialerDept}</div>
                </Col>
            </Row>
        </div>
    )
}

export default SmsPhoneNumberGeneralInfo
